'use strict';

export let EditarUsuarioComponent = {
    selector: 'editarUsuario',
    template: require('./editar-usuario.html'),
    bindings: {
        usuario: '<'
    },
    controller: class {

        /*@ngInject*/
        constructor(UsuarioService, $location, ToasterService){
            Object.assign(this, {UsuarioService, $location, ToasterService});
        }

        editarUsuario(form){
            if (form.$valid){
                if (!this.isNuevoPassword){
                    delete this.usuario.password;
                }
                this.UsuarioService.editarUsuario(this.usuario)
                    .then((data) => {
                        this.ToasterService.popUp('success','Usuario', 'Se ha actualizado con éxito.');
                        this.$location.path('/usuarios')
                    })
            }
        }

        toggleActivo(value){
            this.usuario.active = value;
        }

    }
};


// WEBPACK FOOTER //
// ./client/app/usuario-route/editar/editar-usuario.component.js